import axios from 'axios';

import { SaladAiAnswer, SaladAiRecommendations, SaladAiSurvey } from '@lib/entities/SaladAi';

import client, { ApiError, handleAxiosError, wrapApiCall } from './client';

export const getSaladAiSurvey = wrapApiCall(async (): Promise<SaladAiSurvey | undefined> => {
    const response = await client.get('v3/saladai/survey');
    return response.data;
});

export async function submitSaladAiAnswers(
    answers: SaladAiAnswer[]
): Promise<SaladAiRecommendations | ApiError> {
    try {
        const data = await client.post('v4/saladai/survey', { answers: answers });
        return data.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error) {
            if (error.response?.data?.error) {
                return error.response?.data as ApiError;
            }
            return handleAxiosError(error);
        }
        throw error;
    }
}
